import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigoReferencia} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigoReferencia", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Código de referencia"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigoBarra} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigoBarra", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Código de barra"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMarca ?
                                    { key: this.props.filter.idMarca } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Marca" />}
                            onChange={(option) => this.props.onChange("idMarca", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.marcas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idEstablecimiento ?
                                    { key: this.props.filter.idEstablecimiento } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.establecimientos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idListaPrecio ?
                                    { key: this.props.filter.idListaPrecio } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por lista precio" />}
                            onChange={(option) => this.props.onChange("idListaPrecio", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.listaPrecios.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;